import { useState } from "react";
import { Link } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, Mail } from "lucide-react";
import { toast } from "sonner";

export default function Forgot() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await api.post("/auth/forgot-password", { email }); setSent(true); }
    catch (e2) { toast.error(apiError(e2)); }
    setLoading(false);
  };

  return (
    <div className="vp-dark min-h-screen flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <Link to="/" className="block text-center mb-8"><span className="font-display text-4xl font-bold text-white">Vision<span className="vp-accent-text">POS</span></span></Link>
        <div className="vp-card rounded-2xl p-8">
          {sent ? (
            <div className="text-center py-6">
              <div className="h-14 w-14 rounded-full grid place-items-center mx-auto mb-4" style={{ background: "rgba(61,187,44,0.15)" }}><Mail className="vp-accent-text" /></div>
              <h1 className="font-display text-2xl font-bold text-white mb-2">Email envoyé</h1>
              <p className="text-sm text-slate-400">Si un compte existe pour <b className="text-white">{email}</b>, vous recevrez un lien de réinitialisation.</p>
              <Link to="/login"><Button className="mt-6 vp-accent-bg text-black font-medium">Retour à la connexion</Button></Link>
            </div>
          ) : (
            <>
              <h1 className="font-display text-3xl font-bold text-white mb-1">Mot de passe oublié</h1>
              <p className="text-sm text-slate-400 mb-6">Entrez votre email pour recevoir un lien de réinitialisation</p>
              <form onSubmit={submit} className="space-y-4">
                <div><Label className="text-slate-300 text-sm mb-1.5 block">Email</Label>
                  <Input value={email} onChange={(e) => setEmail(e.target.value)} type="email" required data-testid="forgot-email" className="bg-black/30 border-white/10 text-white" /></div>
                <Button type="submit" disabled={loading} data-testid="forgot-submit" className="w-full vp-accent-bg text-black font-semibold">
                  {loading && <Loader2 className="animate-spin mr-2" size={16} />} Envoyer le lien
                </Button>
              </form>
              <p className="text-center text-sm text-slate-400 mt-6"><Link to="/login" className="vp-accent-text hover:underline">Retour à la connexion</Link></p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
